module.exports = __webpack_public_path__ + "static/media/sf_500.cb7cda046491b6855f4de6240764ec61.png";